// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b887a1c5","453":"da94be67","455":"e66b44ca","762":"1f367395","977":"f21403ba"}[chunkId] + ".chunk.js";
};